import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PageHeader from "components/PageHeader";

function HomeworkResolutionPage() {
    const location = useLocation();
    const navigate = useNavigate();
    const { resolutionData, eleveId } = location.state || {};

    if (!resolutionData) {
        return (
            <div className="flex flex-col h-full">
                <PageHeader title="Résolution d'exercice" path={`/${eleveId}/homework`} />
                <div className="flex-1 overflow-auto p-4">
                    <div className="text-center text-gray-500">
                        Aucune donnée de résolution disponible
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="flex flex-col h-[100dvh]">
            <PageHeader title="Résolution d'exercice" path={`/${eleveId}/homework`} />

            <div className="flex-1 overflow-auto bg-[rgba(0,0,0,0.03)]">
                <div className="p-4 space-y-6 max-w-2xl mx-auto">
                    {/* Problèmes résolus */}
                    <div className="bg-white p-4 rounded-lg shadow">
                        <h3 className="font-semibold mb-4">Solutions</h3>
                        <div className="space-y-4">
                            {resolutionData.solved_problems?.map((problem, index) => (
                                <div key={index} className="border-b border-gray-100 last:border-0 pb-4 last:pb-0">
                                    <div className="flex items-center justify-between">
                                        <div className="flex-1">
                                            <p className="text-gray-700">{problem.problem}</p>
                                        </div>
                                        <div className="ml-4">
                                            <span className="bg-primary text-white px-3 py-1 rounded-full text-sm">
                                                {problem.result}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Boutons de navigation */}
                    <div className="space-y-3">
                        <button
                            onClick={() => navigate(`/${eleveId}/homework`)}
                            className="w-full bg-primary text-white px-6 py-3 rounded-lg hover:bg-primary/90 transition-colors"
                        >
                            Nouvelle aide aux devoirs
                        </button>
                        <button
                            onClick={() => navigate("/parentProspect/select-enfant")}
                            className="w-full bg-white text-primary border-2 border-primary px-6 py-3 rounded-lg hover:bg-primary/5 transition-colors"
                        >
                            Retour à la liste des enfants
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HomeworkResolutionPage; 